import { type DomainAccessControlConfig } from '../../../utils/domain/accessControl'

export const enterpriseStatusPageAccessControl: DomainAccessControlConfig = {}
